<template>
  <div>
    <h1
      v-if="isCompleted"
      class="password_title"
    >
      {{ $t('password.set.completed') }}
    </h1>
    <h1
      v-else
      class="password_title"
    >
      {{ $t('password.mail_send.title.password_reset') }}
    </h1>
    <div class="password_contents">
      <template v-if="isCompleted">
        <div class="password_contents_text_block">
          <p class="password_contents_text">
            {{ $t('password.set.contents_text') }}
          </p>
          <button
            type="button"
            class="password_btn button_orange"
            @click="moveLogin"
          >
            {{ $t('password.set.move_login') }}
          </button>
        </div>
      </template>
      <template v-else>
        <div
          v-loading="isSubmit"
          class="password_form_block"
        >
          <div class="password_item">
            <p class="password_item_title">
              {{ $t('password.reset.new_password') }}
            </p>
            <input
              v-model="newPassword"
              class="password_item_input"
              type="password"
              :class="{ is_error: isNewPasswordError }"
            >
            <p
              v-for="(errorMessage, key) in newPasswordErrorMessages"
              :key="key"
              class="password_item_error_text"
            >
              <span
                class="icon icon_exclamation icon_small password_item_error_text_icon"
              />{{ errorMessage }}
            </p>
          </div>
          <div class="password_item">
            <p class="password_item_title">
              {{ $t('password.reset.new_password_confirmation') }}
            </p>
            <input
              v-model="newPasswordConf"
              class="password_item_input"
              type="password"
              :class="{ is_error: isNewPasswordConfError }"
            >
            <p
              v-for="(errorMessage, key) in newPasswordConfErrorMessages"
              :key="key"
              class="password_item_error_text"
            >
              <span
                class="icon icon_exclamation icon_small password_item_error_text_icon"
              />{{ errorMessage }}
            </p>
          </div>
          <button
            type="button"
            class="password_btn button_orange"
            @click="submit"
          >
            {{ $t('password.reset.set') }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import PasswordApi from '../../api/PasswordApi';
import route from '../../common/route-helper';

export default {
  props: {
    userId: {
      type: Number,
      required: true,
    },
    signature: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const store = useStore();
    const isCompleted = ref(false);
    const isSubmit = ref(false);
    const newPassword = ref('');
    const newPasswordConf = ref('');
    const newPasswordErrorMessages = ref([]);
    const newPasswordConfErrorMessages = ref([]);
    const isNewPasswordError = computed(
      () => newPasswordErrorMessages.value.length > 0,
    );
    const isNewPasswordConfError = computed(
      () => newPasswordConfErrorMessages.value.length > 0,
    );

    const emitError = () => {
      store.dispatch('toast/openToast', {
        kind: 'error',
        text: t('password.reset.error'),
      });
    };
    const submit = () => {
      isSubmit.value = true;
      PasswordApi.setPassword({
        new_password: newPassword.value,
        new_password_confirmation: newPasswordConf.value,
        user_id: props.userId,
        signature: props.signature,
      })
        .then((returnValue) => {
          const { result, errorMessages } = returnValue;
          if (result) {
            isCompleted.value = true;
            return;
          }
          newPasswordErrorMessages.value = errorMessages?.new_password || [];
          newPasswordConfErrorMessages.value = errorMessages?.new_password_confirmation || [];
          if (!errorMessages) {
            emitError();
          }
        })
        .catch(() => {
          emitError();
        })
        .finally(() => {
          isSubmit.value = false;
        });
    };
    const moveLogin = () => {
      window.location.href = route('login');
    };

    return {
      isCompleted,
      isSubmit,
      newPassword,
      newPasswordConf,
      newPasswordErrorMessages,
      newPasswordConfErrorMessages,
      isNewPasswordError,
      isNewPasswordConfError,
      submit,
      moveLogin,
    };
  },
};
</script>
